export default __webpack_public_path__ + "static/media/cabbages.797500b0.png";